import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateInvitation = async (data) => {
  const { invitationId, orgId, requestBody } = data
  const url = `v1/orgs/${orgId}/invitations/${invitationId}`
  return axiosInstance.patch(url, requestBody)
}

export default updateInvitation
